import { BRANCHES_ERROR, BRANCHES_LOADING, BRANCHES_SUCCESS, HEALTHCARE_PROVIDERS_ERROR, HEALTHCARE_PROVIDERS_LOADING, HEALTHCARE_PROVIDERS_SUCCESS, RIPS_HISTORY_ERROR, RIPS_HISTORY_LOADING, RIPS_HISTORY_SUCCESS,RIPS_CONTENT_CLEAR ,FILTER_SUCCESS,FILTER_CLEAR, DOWNLOAD_FILES_LOADING, DOWNLOAD_FILES_ERROR} from "./types"

export default {
    [BRANCHES_SUCCESS]: (state, payload) => {
        state.filters.branches.content = payload
    },
    [BRANCHES_ERROR]: (state, payload) => {
        state.filters.branches.errorAlert = payload
    },
    [BRANCHES_LOADING]: (state, payload) => {
        state.filters.branches.loading = payload
    },
    [HEALTHCARE_PROVIDERS_SUCCESS]: (state, payload) => {
        state.filters.healthcareProviders.content = payload
    },
    [HEALTHCARE_PROVIDERS_ERROR]: (state, payload) => {
        state.filters.healthcareProviders.errorAlert = payload
    },
    [HEALTHCARE_PROVIDERS_LOADING]: (state, payload) => {
        state.filters.healthcareProviders.loading = payload
    },
    [RIPS_HISTORY_SUCCESS]: (state, payload) => {
        state.rips.body = payload
    },
    [RIPS_HISTORY_ERROR]: (state, payload) => {
        state.rips.errorAlert = payload
    },
    [RIPS_HISTORY_LOADING]: (state, payload) => {
        state.rips.loading = payload
    },
    [RIPS_CONTENT_CLEAR]: (state) => {
        localStorage.removeItem('filters')
        state.rips.body.content = []
    },
    [FILTER_SUCCESS]: (state,payload) => {
        state.state.filters.content = payload
    },
    [FILTER_CLEAR]: (state) => {
        state.state.filters.content = []
    },
    [DOWNLOAD_FILES_LOADING]: (state, payload) => {
        state.files.loading = payload
    },
    [DOWNLOAD_FILES_ERROR]: (state, payload) => {
        state.files.errorAlert = payload
    },
}